module.exports = __webpack_public_path__ + "static/media/icon-gmb.466569d2.svg";